const fullTimeWorkerPeriods = [
  { label: 'なし', value: 0 },
  { label: '〜半年', value: 1 },
  { label: '〜1年', value: 2 },
  { label: '〜2年', value: 3 },
  { label: '〜3年', value: 4 },
  { label: '3年以上', value: 5 }
]

export default {
  data: function () {
    return {
      fullTimeWorkerPeriods
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/FullTimeWorkerPeriodMixin.js